// customFolderPlugin.js

window.tinyMCE.PluginManager.add('customfolder', function (editor) {
  editor.ui.registry.addIcon(
    'folderIcon',
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">' +
      '<path d="M20 6H10L8 4H4C2.9 4 2 4.9 2 6v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM4 18V8h16v10H4z"/>' +
      '</svg>'
  );

  editor.ui.registry.addButton('customfolder', {
    icon: 'folderIcon',
    tooltip: 'Insert Folder', // Set the tooltip for the button
    onAction: function () {
      editor.windowManager.open({
        title: 'Insert Folder',
        body: {
          type: 'panel',
          items: [
            {
              type: 'input',
              name: 'folderTitle',
              label: 'Folder Title'
            }
          ]
        },
        buttons: [
          {
            text: 'Insert',
            type: 'submit',
            primary: true
          },
          {
            text: 'Cancel',
            type: 'cancel'
          }
        ],
        onSubmit: function (api) {
          const data = api.getData();
          const folderTitle = data.folderTitle || 'Untitled Folder';

          const folderHtml = `
              <div class="folder">
                <div class="folder-header">${folderTitle}</div>
                <div class="folder-content"></div>
              </div>
            `;
          editor.insertContent(folderHtml);
          api.close();
        }
      });
    }
  });

  editor.on('init', () => {
    editor.getBody().addEventListener('click', e => {
      if (e.target && e.target.classList.contains('folder-header')) {
        const content = e.target.nextElementSibling;
        if (content) {
          content.classList.toggle('open');
        }
      }
    });
  });
});
